import { useCurrentModule } from '../ModuleProvider';
export const useSelectCycleFromMonthlyNote = () => {
  const module = useCurrentModule();
  return (cycleId, action) => event => {
    event.stopPropagation();
    module.internals.bi.onMonthlyCycleSectionHelperLinkClick == null || module.internals.bi.onMonthlyCycleSectionHelperLinkClick({
      action
    });
    module.SDK.PackagePickerStore.setSelectedCycleId(cycleId);
  };
};
//# sourceMappingURL=useSelectCycleFromMonthlyNote.js.map